import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(AccountsResource, Alert, GroupsResource, $scope, $timeout) {
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.accounts = [];
        this.isLoading = true;

        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
                this.Alert('success', 'global.data_copied')
            })
        })

        this.GroupsResource
            .getAllAccountsForCompanyAndGroupAndApplication(this.companyId, this.groupId, this.appId)
            .then(accounts => accounts.map(account => (
                {...account, 
                    searchObj: [account.username, account.user.saaspassId, account.user.displayName]
                })))
            .then(accounts => this.accounts = accounts)
            .finally(() => this.isLoading = false)
    }

    getCode(account) {
        const accountId = account.id;
        return this.AccountsResource
            .getComputerLoginCodeForAccount(this.companyId, this.appId, accountId)
            .then((data) => {
                account.mustRenewCode = false;
                account.code = data.code;
            })
            .then(() => this.$timeout(30000))
            .then(() => account.mustRenewCode = true);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/generate-login-code/generate-login-code.controller.js